var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfoCircle = function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#infoCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.083 13.75h1.834v1.833h-1.834V13.75Zm0-7.333h1.834v5.5h-1.834v-5.5Zm.908-4.584C5.93 1.833 1.833 5.94 1.833 11s4.098 9.167 9.158 9.167c5.069 0 9.176-4.107 9.176-9.167S16.06 1.833 10.99 1.833Zm.009 16.5A7.331 7.331 0 0 1 3.667 11 7.331 7.331 0 0 1 11 3.667 7.331 7.331 0 0 1 18.333 11 7.331 7.331 0 0 1 11 18.333Z",
    fill: "#40424C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "infoCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgInfoCircle;